import React from 'react'

const Toggle = ({ checked, onChange }) => (
  <button
    type="button"
    onClick={onChange}
    className={`relative w-12 h-7 rounded-full transition-colors ${checked ? 'bg-[#0099ff]' : 'bg-[#d0d4da]'}`}
  >
    <span
      className={`absolute top-[3px] left-[3px] h-[22px] w-[22px] rounded-full bg-white shadow transition-transform ${
        checked ? 'translate-x-[20px]' : ''
      }`}
    />
  </button>
)

export default Toggle
